export const baseRoute = '/o/:orgId';

export const partnerDashboardRoute = 'dashboard';

export const partnerCustomersRoute = 'customers';

export const partnerBrandingRoute = 'branding';

export const partnerAccessRoute = 'access';
export const partnerSubscriptionRenewalsTableRoute = 'access/renewals';
export const partnerRequestsTableRoute = 'access/requests';
export const partnerBillingRoute = 'access/billing';
export const partnerStoreRoute = 'access/store';

export const partnerProtectRoute = 'protect';
export const partnerProtectDeploymentsRoute = 'protect/deployments';

export const partnerMailroomRoute = 'mailroom';

export const partnerVideoRoute = 'video';
export const partnerVideoDeploymentsRoute = 'video/deployments';

export const partnerTermsOfServiceRoute = 'termsOfService';
export const partnerUsersRoute = 'users';

export const partnerVisitorRoute = 'visitor';
